import { Component, ComponentRef, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { AuxiliarService } from '../../services/auxiliar.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-drawer-frame',
  standalone: false,
  templateUrl: './drawer-frame.component.html',
  styleUrl: './drawer-frame.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class DrawerFrameComponent implements OnInit, OnDestroy {
  @Input() iconLeft: string;
  @Input() iconRight: string;
  @Input() iconRightRight: string;
  @Input() iconRightRightTooltip: string;
  @Input() position: string = 'right';
  @Input() titleLeft: string;
  @Input() titleRight: string;
  @Input() width: string = '50vw';

  @ViewChild('dynamicComponentContainerLeft', { read: ViewContainerRef }) containerLeft!: ViewContainerRef;
  @ViewChild('dynamicComponentContainerRight', { read: ViewContainerRef }) containerRight!: ViewContainerRef;

  public componentRef!: ComponentRef<any>;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  public isVisibleLeft: boolean;
  public isVisibleRight: boolean;

  constructor(
    public auxiliarService: AuxiliarService,
  ){}

  ngOnInit(): void {
    // left drawer
    this.auxiliarService.drawerObservables.left
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.isOpen && state.component) {
          this.isVisibleLeft = true;
          if(this.containerLeft) this.containerLeft.clear();
          const ref = this.containerLeft.createComponent(state.component);
          Object.assign(ref.instance, state.data);
          this.iconLeft = state.data?.iconLeft;
          this.titleLeft = state.data?.titleLeft;
          this.width = state.data?.width;
        } else {
          this.isVisibleLeft = false;
          if(this.containerLeft) this.containerLeft.clear();
        }
      });

    // right drawer
    this.auxiliarService.drawerObservables.right
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.isOpen && state.component) {
          this.isVisibleRight = true;
          if(this.containerRight) this.containerRight.clear();
          const ref = this.containerRight.createComponent(state.component);
          Object.assign(ref.instance, state.data);
          this.iconRight = state.data?.iconRight;
          this.iconRightRight = state.data?.iconRightRight;
          this.iconRightRightTooltip = state.data?.iconRightRightTooltip;
          this.titleRight = state.data?.titleRight;
          this.width = state.data?.width;
        } else {
          this.isVisibleRight = false;
          if(this.containerRight) this.containerRight.clear();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public addStyles(position: 'left' | 'right'): void {
    setTimeout(() => {
      const drawerSelector = `.p-drawer.p-drawer-${position}`;
      const drawer = document.querySelector(drawerSelector) as HTMLElement;
      if (drawer) {
        drawer.style.width = this.width;
      }
    });
  }

  public resetStyles(position: 'left' | 'right'): void {
    const drawerSelector = `.p-drawer.p-drawer-${position}`;
    const drawer = document.querySelector(drawerSelector) as HTMLElement;
    if (drawer) {
      drawer.style.width = '';
    }
  }
}
